/**
 * Bir şube / web sitesi.
 *
 * Panel tek kod tabanı üzerinden birden fazla siteyi yönetir; aktif site
 * her API isteğinde X-Site-Id başlığı ile gönderilir.
 */
export class SiteEntity {
    site_id: number | string | null = null;
    site_key: string = "";
    name: string = "";
    short_name: string = "";
    domain: string = "";
    domain_aliases: string = "";
    logo_url: string = "";
    favicon_url: string = "";
    primary_color: string = "";
    form_email: string = "";
    is_default: number | string = 0;
    enabled: number | string = 1;
    no: number | string = 0;
    created_at: string | null = null;
    updated_at: string | null = null;
}

/** İçerik görünürlüğü — şartname §6 */
export enum VisibilityEnum {
    /** Yalnızca seçili şubede göster */
    Site = "site",
    /** Tüm şubelerde göster (ortak içerik) */
    All = "all",
}

export const visibilityOptions = [
    {text: "Yalnızca seçili şubede göster", value: VisibilityEnum.Site},
    {text: "Tüm şubelerde göster (ortak)", value: VisibilityEnum.All},
];
